// extracted by mini-css-extract-plugin
export default {"shimmer":"styles_shimmer__2pytG","shimmerMove":"styles_shimmerMove__+k+YM"};